module.exports = __webpack_public_path__ + "static/media/paper-plane.0e22da5f.svg";